import { Injectable, inject } from "@angular/core";
import { first } from "lodash";
import { Address, addressMerge } from "src/app/backend/models/address";
import {
  addressIsSame,
  formatAddress
} from "src/app/common/format/address-format";
import {
  AddressCheckerSelectComponent,
  AddressCheckerSelectPopupData
} from "src/app/modules/bootstrap/pms-ui/functions/address/address-checker/address-checker-select/address-checker-select.component";
import {
  IndirizzoService,
  IndirizzoServiceSearchResult
} from "src/app/services/indirizzo.service";
import { PopupService } from "src/app/services/popup/popup.service";

type Input = {
  updatedAddress: Address;
  originalAddress: Address;
};

@Injectable({ providedIn: "root" })
export class AddressCheckerFunctionService {
  private readonly indirizzoService = inject(IndirizzoService);
  private readonly popupService = inject(PopupService);

  execute(
    input: Input,
    options?: { popupAttachToBody?: boolean }
  ): Promise<Address | undefined> {
    return new Promise<Address | undefined>(async (res) => {
      const mergedAddress = addressMerge({
        originalAddress: input.originalAddress,
        updatedAddress: input.updatedAddress
      });

      const addressResult: IndirizzoServiceSearchResult[] =
        await this.indirizzoService.search(
          formatAddress(mergedAddress),
          input.updatedAddress.country!
        );

      if (addressResult.length === 1) {
        // se google restituisce un solo risultato ed e' uguale all'indirizzo aggiornato
        // significa che è valido e non chiedo ulteriori inout all'utente
        const addressSearchResult = this.indirizzoService.toAddress(
          first(addressResult)!
        );

        if (addressIsSame(mergedAddress, addressSearchResult)) {
          res(mergedAddress);
          return;
        }
      }

      const result = await this.popupService.show<Address | undefined>(
        AddressCheckerSelectComponent,
        <AddressCheckerSelectPopupData>{
          addressResult: addressResult.map(this.indirizzoService.toAddress),
          originalAddress: input.originalAddress,
          updatedAddress: input.updatedAddress
        },
        {
          dialog: true,
          hideButtonClose: false,
          height:
            addressResult.length === 0
              ? 220
              : Math.max(384, 240 + addressResult.length * 64),
          width: addressResult.length === 0 ? 400 : 520,
          attachToBody: !!options?.popupAttachToBody
        }
      );

      res(result);
    });
  }
}
